<template>
  <v-dialog v-model="isOpen" style="z-index: 1999" max-width="560">
    <template #activator="{ props }">
      <v-btn v-bind="props">
        <v-icon class="mr-2">mdi-plus</v-icon>
        Зарезервувати номер
      </v-btn>
    </template>

    <dialog-template
      submit-label="Зарезервувати"
      title="Резервування номерів"
      subtitle="Зарезервуйте номер для ручної реєстрації"
      @close="isOpen = false"
      @submit="submit">
      <b-select
        v-model="registrationNumber.registrationJournalId"
        :error-messages="getErrorMessages(v$.registrationJournalId)"
        :items="$directory.get('registrationJournals')"
        :loading="$loading.isLoading('registrationJournals')"
        label="Жрунал реєстрації"
        placeholder="Оберіть журнал"
        @blur="v$.registrationJournalId.$touch()"
        @focus="$directory.fill('registrationJournals')"></b-select>

      <b-input
        :model-value="previewNumber"
        label="Номер для резервування"
        readonly></b-input>

      <employee-autocomplete
        v-model="registrationNumber.authorId"
        :error-messages="getErrorMessages(v$.authorId)"
        @blur="v$.authorId.$touch()"></employee-autocomplete>
    </dialog-template>
  </v-dialog>
</template>

<script setup lang="ts">
import { reactive, ref, watch } from 'vue'
import { BInput } from 'best-modules/components'
import { required, useVuelidate } from '@/plugins'
import { getErrorMessages } from '@/utils/helpers'
import { fillDirectory } from '@/directory'
import DialogTemplate from '@/dialog/DialogTemplate.vue'
import EmployeeAutocomplete from '@/components/inputs/employee-autocomplete/EmployeeAutocomplete.vue'
import {
  numberReservationCreate,
  numberReservationPreview,
} from '@/requests/document-registration'
import { setSnackbar } from 'best-modules/plugins'
import { NumberReservationCredentials } from '@/utils/types/documentRegistration'

defineOptions({
  name: 'CreateReservation',
})

const emit = defineEmits<{
  (_name: 'created'): void
}>()

const isOpen = ref<boolean>(false)

const registrationNumber = reactive<NumberReservationCredentials>({
  registrationJournalId: null,
  authorId: null,
} as NumberReservationCredentials)

const previewNumber = ref<string>('')
const rules = {
  registrationJournalId: { required },
  authorId: { required },
}
const v$ = useVuelidate(rules, registrationNumber)

const resetForm = () => {
  registrationNumber.registrationJournalId = null as any
  registrationNumber.authorId = null as any
  previewNumber.value = ''
  v$.value.$reset()
}

const loadPreview = async (registrationJournalId: number | null) => {
  previewNumber.value = ''

  if (registrationJournalId) {
    const res = await numberReservationPreview(registrationJournalId)
    previewNumber.value = res.registrationNumber || ''
  }
}

const submit = async () => {
  v$.value.$validate()
  if (!v$.value.$invalid) {
    const res = await numberReservationCreate({
      registrationJournalId: registrationNumber.registrationJournalId,
      authorId: registrationNumber.authorId,
    })

    setSnackbar({
      text:
        res?.message ||
        `Зарезервовано реєстраційний номер: ${res?.registrationNumber}`,
    })
    emit('created')
    isOpen.value = false
    resetForm()
  }
}

watch(
  () => registrationNumber.registrationJournalId,
  value => {
    loadPreview(value)
  }
)

watch(isOpen, value => {
  if (value) {
    fillDirectory('registrationJournals')
  } else {
    resetForm()
  }
})
</script>
